<template>
  <div class="ah-active-filter">
    <div
      v-if="!!filter.symbol"
      class="ah-active-filter-icon-container"
    >
      <animal-symbol
        class="ah-active-filter-icon"
        :name="filter.symbol"
      />
    </div>
    <div class="ah-active-filter-label">
      {{ filter.name }}
    </div>
    <img
      class="ah-active-filter-close-icon"
      :src="removeFilterIconSrc"
      :alt="accessibleLabel"
      @click="removeFilter"
    />
  </div>
</template>

<script>
  import AnimalSymbol from '../AnimalSymbol.vue'
  import { mutations } from '../../data/store'

  export default {
  components: { AnimalSymbol },
    name: 'active-filter',
    props: {
      removeFilterAccessibleLabel: String,
      filter: Object,
    },
    methods: {
      removeFilter: function() {
        if (this.filter.id === -1) {
          mutations.setSearchParams('')
        } else {
          mutations.toggleFilter(this.filter)
        }
      },
    },
    data() {
      return {
        removeFilterIconSrc: '../../../../../Static/icons/AH/x.svg'
      }
    },
    computed: {
      accessibleLabel: function() {
        return `${this.removeFilterAccessibleLabel}: ${this.label}`
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import "../../../scss/_variablesAH.scss";

  .ah-active-filter {
    border: 1px solid #CCC;
    border-radius: 20px;
    padding: 10px 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #FFF;
    margin: 4px;
    cursor: default;
  }
  .ah-active-filter-icon-container {
    position: relative;
    width: 16px;
    height: 16px;
    margin-right: 6px;
  }
  .ah-active-filter-icon {
    position: absolute;
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    top: -4px;
    left: -4px;
  }
  .ah-active-filter-label {
    font-family: $font-main;
    font-size: 16px;
    color: #555;
    line-height: 19px;
  }
  .ah-active-filter-close-icon {
    margin-left: 4px;
    width: 16px;
    height: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
</style>